<template>
	<v-container style="padding: 0;">
		<v-data-table :headers="data.headers" v-model="selectedItems" :items="data.list" :loading="query.loading" class="elevation-1 mt-5"
			disable-pagination hide-default-footer item-key="id" show-select loading-text="正在加载,请稍候......" no-data-text="暂无数据">
			<template v-slot:top>
				<v-row dense>
					<v-col cols="12" class="d-flex flex-wrap">
						<div style="width: 200px;" class="mr-1">
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="开始上课日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
								</v-date-picker>
							</v-menu>
						</div>
						<div style="width: 200px;" class="mr-1">
							<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="结束上课日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
								</v-date-picker>
							</v-menu>
						</div>
						<div style="width: 150px;" class="mr-1">
							<v-select :items="statusItems" v-model="query.status" item-text="statusName"
								item-value="id" label="状态" dense outlined></v-select>
						</div>
						<v-btn @click="queryClicked" color="info">查询</v-btn>
					</v-col>
					<v-col cols="12" class="mt-n6">
						<v-btn small color="info" class="mr-1" @click="showAddRecord">添加排课</v-btn>
						<!-- <v-btn small color="info" class="mr-1" @click="toUpdateRecord">修改排课</v-btn> -->
						<v-btn small color="info" class="mr-1" @click="toBatchCancel">批量删除</v-btn>
						<v-btn small color="info" class="mr-1" @click="toBatchDelay">批量顺延</v-btn>
						<v-btn small color="info" class="mr-1" @click="undoDelayRecord">撤销顺延</v-btn>
					</v-col>
				</v-row>
			</template>
			
			
			<template v-slot:item.classDate="{item}">
				<span>{{ item.classDate }}</span>
				
				<v-chip v-if="item.isAllowBook=='1'" color="success" outlined small class="ml-1 mt-n1">约</v-chip>
			</template>
			<template v-slot:item.weekAt="{item}">
				{{ weekName(item.weekAt) }}
			</template>
			<template v-slot:item.timeRange="{item}">
				{{item.timeFrom}}-{{item.timeTo}}
			</template>
			<template v-slot:item.status="{item}">
				
				<span v-if="item.status =='1'"  style="color:#FF9100">待核销</span>
				<span v-if="item.status =='2'" >已核销</span>
				<span v-if="item.status =='3'" style="color:#43A047;">已顺延</span>

			</template>
			
			<template v-slot:item.action="{item}">
				<v-btn small color="info" @click="showRecordView(item)">详情</v-btn>
			</template>
		
		</v-data-table>
		<div class="pt-2">
			<v-row dense>
				<v-col cols="2" >
					<v-select :items="[10, 20, 50, 100]" @change="handleSizeChanged" dense hide-details label="每页数量"
						outlined v-model="query.size" />
				</v-col>
				<v-col cols="1" class="mt-2">
					<span>共{{data.total}}项</span>
				</v-col>
				<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
					<v-pagination :length="Math.ceil(data.total/query.size)" @input="handlePageChanged"
						total-visible="5" v-model="query.page" />
				</v-col>
			</v-row>
		</div>
		
		<!-- 批量删除 dialog -->
		<v-dialog title="批量取消" v-model="batchDelete.dialog" max-width="600" persistent>
			<v-card>
				<v-card-title>批量取消排课</v-card-title>
				<v-card-text>
					<v-row class="mb-2 mt-2" rounded>
						<v-col cols="12">
							<v-alert dense type="warning">选中的{{selectedItems.length}}条排课记录都将会被取消</v-alert>
						</v-col>
						<v-col cols="12" class="mt-n3">
							<span style="font-size:16px">是否确认取消排课记录？</span>
						</v-col>
					</v-row>
					
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="batchDelete.dialog=false">放弃</v-btn>
					<v-btn @click="submitBatchDelete" :disabled="batchDelete.submitting" :loading="batchDelete.submitting" color="success">确定取消</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 批量顺延 dialog -->
		<v-dialog title="批量顺延" v-model="batchDelay.dialog" max-width="600" persistent>
			<v-card>
				<v-card-title>批量顺延课次</v-card-title>
				<v-card-text>
					<v-row class="mb-2 mt-2" rounded>
						<v-col cols="12">
							<v-alert dense type="warning">选中的{{selectedItems.length}}条排课记录都将会被顺延</v-alert>
						</v-col>
						<v-col cols="12" class="mt-n3">
							<span style="font-size:16px">是否确认顺延排课记录？</span>
						</v-col>
					</v-row>
					
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="batchDelay.dialog=false">取消</v-btn>
					<v-btn @click="submitBatchDelay" :disabled="batchDelay.submitting" :loading="batchDelay.submitting" color="success">确定顺延</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 核销组件 -->
		<!-- <approveRecord :show="approve.show" :recordId="approve.recordId" @cancel="approve.show=false" @success="approveSuccess"></approveRecord> -->
		
		<!-- 添加排课组件 -->
		<classRecordAdd :show="addRecord.show" :classId="addRecord.classId" @cancel="addRecord.show=false" @success="addRecordSuccess"></classRecordAdd>
		
		<!-- 修改排课组件 -->
		<!-- <classRecordUpdate :show="updateRecord.show" :record="updateRecord.record" @cancel="updateRecord.show=false" @success="updateRecordSuccess"></classRecordUpdate> -->
		
		<!-- 撤销核销 -->
		<!-- <cancelApproveRecord :show="cancelApprove.show" :recordId="cancelApprove.recordId" @cancel="cancelApprove.show=false" @success="cancelApproveSuccess"></cancelApproveRecord> -->
		
		<!-- 课次详情 -->
		<recordInfoView :show="recordView.show" :recordId="recordView.recordId" @cancel="recordView.show=false"></recordInfoView>
		
	</v-container>
</template>

<script>
	import global from "../config/global"
	//import approveRecord from "./approve_record.vue"
	import classRecordAdd from "./class_record_add.vue"
	//import classRecordUpdate from "./class_record_update.vue"
	//import cancelApproveRecord from "./cancel_approve_record.vue"
	import recordInfoView from "./record_info_view.vue"
	export default {
		name:"class-record-list",
		components:{
		
			classRecordAdd,

			recordInfoView
		},
		props:{
			classId:{
				type:String,
				default:""
			}
		},
		watch:{
			classId(newVal,oldVal){
				if (newVal&&newVal != oldVal){
					this.selectedItems = [];
					this.getDataList();
				}
			}
		},
		data(){
			return {
				menu1:false,
				menu2:false,
				query:{
					loading:false,
					page:1,
					size:10,
					status:"",
					start:"",
					end:"",
				},
				selectedItems:[],
				statusItems:[
					{id:"",statusName:"全部"},
					{id:"1",statusName:"待核销"},
					{id:"2",statusName:"已核销"},
					{id:"3",statusName:"已顺延"},
				],
				weekItems:global.weekList,
				data: {
					total:0,
					headers:[
						{
							text: '上课日期',
							value: 'classDate',
							sortable: false
						},
						{
							text: '周几',
							value: 'weekAt',
							sortable: false
						},
						{
							text: '时间段',
							value: 'timeRange',
							sortable: false
						},
						{
							text: '老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '教室',
							value: 'roomName',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list:[],
					
				},
				
				addRecord:{
					show:false,
					classId:""
				},
				batchDelete:{
					dialog: false,
					submitting:false,
				},
				batchDelay:{
					dialog: false,
					submitting:false,
				},
			
				
				recordView:{
					show:false,
					recordId:""
				}
				
			}
		},
		mounted() {
			console.log("class-record-list mounted");
			this.getDataList();
		
		},
		methods:{
			queryClicked(){
				this.query.page = 1;
				this.getDataList();
			},
			handleSizeChanged(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getDataList();
			},
			handlePageChanged(page) {
				this.query.page = page;
				this.getDataList();
			},
			statusName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "待核销";
				} else if (state === "0") {
					stName = "已取消";
				}else if (state === "2") {
					stName = "已核销";
				}else if (state === "3") {
					stName = "已顺延";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "0") {
					color = "error";
				}else if (state === "2") {
					color = "success";
				}else if (state === "3") {
					color = "grey";
				}
			
				return color;
			},
			weekName(wk) {
			
				let stName = "未知";
				this.weekItems.forEach((item,index)=>{
					if (item.week == wk){
						stName = item.weekName;
					}
				})
				return stName;
			},
			getDataList(){
				const that = this;
				const classId = this.classId;
				let url = `/edu/class/record/list/in/${classId}/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if(this.query.start){
					url += "&start="+this.query.start;
				}
				if(this.query.end){
					url += "&end="+this.query.end;
				}
				if(this.query.status){
					url += "&status="+this.query.status;
				}
							
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						console.log(response.data);
						
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				})
			},
			cancel(){
				this.$emit("cancel","")
			},
			
			showRecordView(item){
				this.recordView.recordId = item.id;
				this.recordView.show = true;
			},
			
			
			
			showAddRecord(){
				this.addRecord.classId = this.classId;
				this.addRecord.show = true;
			},
			addRecordSuccess(){
				this.addRecord.show=false;
				this.getDataList();
				
				// 触发dataChange事件  class——teail里刷新detail
				this.$emit("dataChanged","")
			},
			
			toBatchCancel(){
				// 点击批量取消
				if (this.selectedItems.length == 0){
					this.$noty.error('至少选择一条数据');
					return
				}
				this.batchDelete.dialog = true;
				console.log(this.selectedItems);
			},
			submitBatchDelete(){
				//批量取消
				if (this.selectedItems.length == 0){
					this.$noty.error('没有选中的数据');
					return
				}
				let ids = [];
				this.selectedItems.forEach((item,index)=>{
					ids.push(item.id);
				});
				
				
				
				this.batchDelete.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/batch/cancel`;
				
				let postData = {}
				postData.ids = ids;
				
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.getDataList();
							that.batchDelete.dialog = false;
							that.batchDelete.submitting = false;
							that.selectedItems = [];
							return;
						} else {
							that.batchDelete.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.batchDelete.submitting = false;
						that.$noty.error('网络请求失败');
					}
				});
			},
			toBatchDelay(){
				// 点击批量顺延
				if (this.selectedItems.length == 0){
					this.$noty.error('至少选择一条数据');
					return
				}
				this.batchDelay.dialog = true;
				
			},
			submitBatchDelay(){
				//批量顺延
				if (this.selectedItems.length == 0){
					this.$noty.error('没有选中的数据');
					return
				}
				let ids = [];
				this.selectedItems.forEach((item,index)=>{
					
					ids.push(item.id);
				});
				
				this.batchDelay.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/batch/delay`;
				
				let postData = {}
				postData.ids = ids;
				
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.getDataList();
							that.batchDelay.dialog = false;
							that.batchDelay.submitting = false;
							that.selectedItems = [];
							return;
						} else {
							that.batchDelay.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.batchDelay.submitting = false;
						that.$noty.error('网络请求失败');
					}
				});
			},
			undoDelayRecord(){
				// 撤销顺延排课记录
				if (this.selectedItems.length == 0){
					this.$noty.error('没有选中的数据');
					return
				}
				let ids = [];
				let errorIndexs = [];
				this.selectedItems.forEach((item,index)=>{
					if (item.status !='3'){
						errorIndexs.push(index+1);
					}else{
						ids.push(item.id);
					}
					
				});
				// 有错误数据行
				if(errorIndexs.length > 0){
					let lines = errorIndexs.join(",");
					this.$noty.error(`第${lines}行,状态不是已顺延,无法撤销`);
					return;
				}
				
				console.log("ids",ids);
				
				const that = this;
				let url = `/edu/class/record/delay/undo`;
				this.axios.post(url,ids).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			
		}
	}
	
</script>


<style>
</style>
